/* Redirect search submit to a collection when q matches a known title or handle. */
(function () {
  function loadMap() {
    var el = document.getElementById('search-collection-map');
    if (!el) return { byTitle: {}, byHandle: {}, catalogUrl: '' };
    var entries;
    try {
      entries = JSON.parse(el.textContent);
    } catch (e) {
      return { byTitle: {}, byHandle: {}, catalogUrl: el.getAttribute('data-catalog-url') || '' };
    }
    var byTitle = {};
    var byHandle = {};
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      if (!entry || !entry.url) continue;
      if (entry.title) byTitle[String(entry.title).toLowerCase()] = entry.url;
      if (entry.handle) byHandle[String(entry.handle).toLowerCase()] = entry.url;
    }
    return {
      byTitle: byTitle,
      byHandle: byHandle,
      catalogUrl: el.getAttribute('data-catalog-url') || ''
    };
  }

  function normalizeQuery(q) {
    return (q || '').replace(/\s+/g, ' ').trim();
  }

  function slugify(text) {
    return String(text)
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function init() {
    var map = loadMap();

    function urlForQuery(q) {
      var normalized = normalizeQuery(q);
      if (!normalized) return null;
      var lower = normalized.toLowerCase();
      if (lower === 'collections' && map.catalogUrl) return map.catalogUrl;
      if (map.byTitle[lower]) return map.byTitle[lower];
      if (map.byHandle[lower]) return map.byHandle[lower];
      var slug = slugify(normalized);
      if (slug && map.byHandle[slug]) return map.byHandle[slug];
      return null;
    }

    function onSubmit(e) {
      var input = e.target.querySelector('[name="q"]');
      if (!input) return;
      var url = urlForQuery(input.value);
      if (!url) return;
      e.preventDefault();
      window.location.assign(url);
    }

    function bindForm(form) {
      if (!form || form.dataset.collectionRedirectBound) return;
      form.dataset.collectionRedirectBound = 'true';
      form.addEventListener('submit', onSubmit);
    }

    bindForm(document.querySelector('.header__search-bar form'));
    bindForm(document.getElementById('predictive-search-form'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
